import React from 'react';
import { SxProps } from '@mui/material';
import { ColorPalette, TypographyFamily } from '../../../styles/constants';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';

export interface AppButtonProps {
  onClick?(): void;
  label: string;
  isPrimary?: boolean;
  isLoading?: boolean;
  sx?: SxProps;
  buttonType?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export function AppButton({
  onClick,
  label,
  isPrimary = false,
  sx,
  buttonType = 'button',
  isLoading = false,
  disabled = false,
}: AppButtonProps): JSX.Element {
  return (
    <LoadingButton
      onClick={onClick}
      loading={isLoading}
      loadingPosition={isLoading ? 'start' : 'center'}
      startIcon={isLoading ? <SaveIcon /> : null}
      disabled={disabled}
      fullWidth
      sx={{
        fontFamily: TypographyFamily.NEXA,
        fontWeight: 700,
        fontSize: '16px',
        boxShadow: '0 0 3px #f1f1f1',
        borderRadius: 0,
        color: isPrimary ? ColorPalette.CONFIRM_BLUE : ColorPalette.DARK_GRAY,
        ...sx,
      }}
      type={buttonType}
    >
      {label}
    </LoadingButton>
  );
}
